<template>
  <v-col>
    <!-- Stock data table -->
    <stock-table
      :key="index"
      url-create="BuyBySuppilier"
      url-api="/stock"
      :headers="headers"
      :no-search="true"
    >
      <!-- Product Stock -->
      <template v-slot:product="{ item }">
        <v-icon
          @click="
            $router.push({
              name: 'ProductDetail',
              params: { id: item.product_id },
            })
          "
        >
          mdi-link-variant
        </v-icon>
        {{ item.product.name | capitalize }}
      </template>
      <!-- end -->

      <!-- Stock Store at  -->
      <template v-slot:warehouse="{ item }">
        <v-icon
          @click="
            $router.push({
              name: 'WarehouseDetail',
              params: { id: item.warehouse_id },
            })
          "
        >
          mdi-link-variant
        </v-icon>
        {{ item.warehouse.name | capitalize }}
      </template>
      <!-- end -->

      <!-- Cost -->
      <template v-slot:cost="{ item }">
        {{ item.cost | currency }}
      </template>
      <!-- end -->

      <!-- Price -->
      <template v-slot:price="{ item }">
        {{ item.price | currency }}
      </template>
      <!-- end -->
    </stock-table>
    <!-- end data table -->
  </v-col>
</template>

<script>
import StocksTable from "../common/DataTable.vue";
export default {
  components: {
    "stock-table": StocksTable,
  },
  data() {
    return {
      index: 1,
      headers: [
        {
          text: "Added At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Product",
          sortable: true,
          slot: "product",
        },
        {
          text: "Store At",
          sortable: true,
          slot: "warehouse",
        },
        {
          text: "Sold",
          sortable: true,
          value: "sold",
        },
        {
          text: "Returned",
          sortable: true,
          value: "returned",
        },
        {
          text: "Remaining QTY",
          sortable: true,
          value: "quantity",
        },
        {
          text: "Buying Cost",
          sortable: true,
          slot: "cost",
        },
        {
          text: "Sale Price",
          sortable: true,
          slot: "price",
        },
      ],
    };
  },
};
</script>
